// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__lfzdm","title":"Images90_title__1rm9j","images":"Images90_images__3oubq"};